/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateCustomerRequest
 */
export interface CreateCustomerRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateCustomerRequest
     */
    values?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateCustomerRequest interface.
 */
export function instanceOfCreateCustomerRequest(value: object): boolean {
    return true;
}

export function CreateCustomerRequestFromJSON(json: any): CreateCustomerRequest {
    return CreateCustomerRequestFromJSONTyped(json, false);
}

export function CreateCustomerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCustomerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'values': json['values'] == null ? undefined : json['values'],
    };
}

export function CreateCustomerRequestToJSON(value?: CreateCustomerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'values': value['values'],
    };
}

